// extracted by mini-css-extract-plugin
export default {"page":"Userinfo_page__EyWei","login_root":"Userinfo_login_root__1mf5P"};